import React, { useCallback, useMemo } from 'react';
import {
  BetResponseCode,
  notificationStore,
  parseNumberByPrecision,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { candyDataStore } from '../../../store';
import { gameStore } from '../../../store';
import { TranslationKeys } from '../../../enums';
import { betResponseCodeByName } from '../../../enums/additionalNotifications';

export const AdditionalBetButtons = observer(({ activeFreeBet }) => {
  const t = useTranslation();
  const { candiesBetData: candiesData, reBetData } = candyDataStore;
  const { limits } = gameConfigStore;
  const { isBetsClosed } = gameStore;
  const { balance } = userInfoStore;
  const additionalBetButtonsData = useMemo(
    () => [
      { label: t(TranslationKeys.Min), value: 0, title: t(TranslationKeys.Min) },
      { label: '1/2', value: 0.5, title: '1/2' },
      { label: 'x2', value: 2, title: 'x2' },
      { label: 'x3', value: 3, title: 'x3' },
      {
        label: t(TranslationKeys.Repeat),
        value: 3,
        isTranslatable: true,
        isReBet: true,
        title: t(TranslationKeys.ReBet),
        isDisabled: !reBetData || candiesData.some((el) => el.amount),
      },
    ],
    [t, candiesData, reBetData]
  );

  const handleAdditionalBetButton = useCallback(
    (value) => {
      if (!isBetsClosed && !activeFreeBet.id) {
        if (candiesData.some((item) => item.amount)) {
          const updatedCandiesBetData = candiesData.map((candy) => {
            if (candy.amount) {
              const { minBet, maxBet } = limits;

              if (value) {
                let updatedAmount = parseNumberByPrecision(candy.amount, value);
                if (updatedAmount > maxBet) {
                  notificationStore.setNotificationType({
                    responseCode: BetResponseCode.InValidMaxBet,
                  });
                  updatedAmount = maxBet;
                } else if (updatedAmount < minBet) {
                  notificationStore.setNotificationType({
                    responseCode: BetResponseCode.InValidMinBet,
                  });
                  updatedAmount = minBet;
                }

                candy.amount = updatedAmount;
              } else {
                candy.amount = minBet;
              }
            }

            return { ...candy };
          });

          // const pendingBetAmount = updatedCandiesBetData.reduce((acc, curr) => {
          //   if (curr.amount) {
          //     return acc + curr.amount;
          //   }
          //   return acc;
          // }, 0);

          // if (isDemo && pendingBetAmount > balance) {
          //   notificationStore.setNotificationType({
          //     responseCode: BetResponseCode.InsufficientFunds,
          //   });
          //   candyDataStore.resetCandiesData();
          //   candyDataStore.resetReBetData();
          // } else {
          candyDataStore.setCandiesBetData(updatedCandiesBetData);
          // }
        }
      }
    },
    [candiesData, limits, balance, isBetsClosed, activeFreeBet]
  );

  const handleReBet = useCallback(() => {
    if (reBetData && !isBetsClosed) {
      const filteredReBetDataByAmount = reBetData?.filter((item) => item?.amount);
      if (activeFreeBet?.id && activeFreeBet?.remainingCount < filteredReBetDataByAmount?.length) {
        notificationStore.setNotificationType({
          responseCode: betResponseCodeByName.NotEnoughFreeBets,
        });
      } else {
        candyDataStore.setCandiesBetData(reBetData);
      }
    }
  }, [reBetData, isBetsClosed, activeFreeBet]);

  const handleKeyDown = useCallback(
    (e, isReBet, value) => {
      e.preventDefault();
      if (isReBet) {
        handleReBet();
      } else {
        handleAdditionalBetButton(value);
      }
    },
    [handleReBet, handleAdditionalBetButton]
  );

  return (
    <div className='bottom-button-wrapper'>
      {additionalBetButtonsData.map(({ label, title, value, isReBet, isDisabled }) => (
        <div
          className={`bottom-button-item ${isReBet ? 'rebet' : 'coef'} ${
            isBetsClosed || (isReBet && isDisabled) ? 'passive' : ''
          }`}
          key={label}
        >
          <button
            className={`bet-button-item-block ${isReBet ? 'rebet' : 'coef'}-btn`}
            onClick={() => (isReBet ? handleReBet() : handleAdditionalBetButton(value))}
            onKeyDown={(e) => handleKeyDown(e, isReBet, value)}
          >
            <p className={isReBet ? 'bet-button-item-block-text' : 'coef-btn-text'} title={title}>
              {label}
            </p>
          </button>
        </div>
      ))}
    </div>
  );
});
